/* eslint-disable func-names, max-len */
if ($('.bannerBtns').length > 0) {
  $('.hoverSlide').hide();
  const speed = 550;
  $('.trade, .systems').hover(function () {
    $(this).find('.initialSlide').stop().hide()
      .animate({
        'margin-top': '-100',
      }, speed);
    $(this).find('.hoverSlide').stop().show()
      .animate({
        'margin-top': '10',
      }, speed);
  }, function () {
    $(this).find('.initialSlide').stop().show()
      .animate({
        'margin-top': '30',
      }, speed);
    $(this).find('.hoverSlide').stop().hide()
      .animate({
        'margin-top': '100',
      }, speed);
  });
}
